<template>
  <div class="RevisionTableComponent DataTables">

    <div v-show="isData" :id="id"></div>

      <LoaderComponent  v-if="!isData"></LoaderComponent>

    </div>
</template>
<script>
  import LoaderComponent from "@/components/shared/LoaderComponent"
  import * as Tools from './../../Tools/Tools'

  import $ from 'jquery';
  import dt from 'datatables.net-bs4';

  export default {
      name: "RevisionTableComponent",
      props:{

        lang: Object
      },
      components: {
        LoaderComponent
      },
      data () {
          return {
            name: "RevisionTableComponent",
            mainTable: "",
            id: "revisionHistory"
          }
      },
      computed: {
        dataTable(){
          return this.$store.getters.revisionHistory;
        },

        isData(){
          
            return Object.keys(this.dataTable).length != 0
            //return this.dataTable.length != 0
        },
        elementId(){
          let value = null;
          if (this.$store.getters.sectionPrefix == "pm") {
            if (this.$store.getters.selectedRows[0] != undefined) {
              if (this.$store.getters.selectedRowslength == 1) {
                value = this.$store.getters.selectedRows[0].col___revisionId.partId;
               }
            } else {
              value = this.$route.query.id;
            }
              
          }
          if (this.$store.getters.sectionPrefix == "lm"){
            value = this.$store.getters.selectedRows[0].col___revisionId.libraryId;
          }
          if (this.$store.getters.sectionPrefix == "projm"){
            value = this.$store.getters.selectedRows[0].col___revisionId.projectId;
          }
          return value;
        },
        reloadedAfterAction(){
            return this.$store.getters.reloadedAfterAction;
        },
      },
      created() {

      

      },
  watch: {
    dataTable: {
        handler: function(newVal){
          
        if (newVal.length == 0) {
          let component = "DataTableFilteredOnApiComponent";
          if (this.$store.getters.sectionPrefix == "lm") {
            component = "DataTableFilteredOnApiLibComponent";
          }
          if (this.$store.getters.sectionPrefix == "projm") {
            component = "DataTableFilteredOnApiProjComponent";
          }

            const reloadObj = {
              status: true,
              name: component
            }
            this.$store.dispatch("reloadAfterAction", reloadObj);

            let to = "/PartManager/PartTable";
            if (this.$store.getters.sectionPrefix == "lm") {
              to = "/LibraryManager/LibraryTable";
            }
            if (this.$store.getters.sectionPrefix == "projm") {
              to = "/ProjectManager/ProjectTable";
            }

            const query = {
              from: this.$route.path,
              to: to,

            }

            this.$router.push({ path: to, query: query });
          }
        },
        deep: true
      
        
      },
    
        // reloadedAfterAction: {
        //   handler: function (newValue) {

        //     for (let el in newValue) {
        //       if (newValue.name == this.name) {
        //         if (newValue[el].status == true) {

        //           this.reloadData();

        //           newValue[el].status = false;

        //           this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
        //         }
        //       }
        //     }
        //   },
        //   deep: true

        // },
    reloadedAfterAction: function(newValue){
      
      
      if (newValue.name == this.name){
        
          if (newValue.status == true){
              
              this.reloadData();
              
              newValue.status = false;
              newValue.name = "";
              this.$store.dispatch("reloadAfterAction", newValue);
          }
      }
        
    }
  },
  updated() {


    this.buildTable();
  },
      methods: {
        reloadData(){
          
          if (this.$store.getters.selectedRows.length > 0){

            let value = null;
            if (this.$store.getters.sectionPrefix == "pm"){
              if (this.$store.getters.selectedRows[0] != undefined) {
                if (this.$store.getters.selectedRows.length == 1) {
                  value = this.$store.getters.selectedRows[0].col___revisionId.partId;
                }
              } else {
                value = this.$route.query.id;
              }
            }
            if (this.$store.getters.sectionPrefix == "lm"){
              value = this.$store.getters.selectedRows[0].col___revisionId.libraryId;
            }
            if (this.$store.getters.sectionPrefix == "projm"){
              value = this.$store.getters.selectedRows[0].col___revisionId.projectId;
            }

            
            this.$store.dispatch(this.$store.getters.sectionPrefix+'_getRevisionHistory', value);
          }

        },

        buildTable(){
          
          this.$store.dispatch("deselectAllRevisionRow")

          var tableplace = document.getElementById(this.id);
          if (tableplace == null) {
            return;
          }
          while (tableplace.firstChild) {
              tableplace.removeChild(tableplace.firstChild);
          }

          var table = document.createElement("table");
          table.setAttribute("id", "t_"+this.id);
          table.setAttribute("class", "table table-striped table-bordered");
          tableplace.appendChild(table)

          var tr = document.createElement("tr");
          tr.setAttribute("class", "cellHeader");
          var thead = document.createElement("thead");
          thead.appendChild(tr);
          table.appendChild(thead);

          var _vue = this;

          let columns = [
            {
              name: this.lang.table_header_Select,
              alignInColumn: "left",

            },
            {
              name: this.lang.table_header_Revision,
              alignInColumn: "left",

            },
            {
              name: this.lang.table_header_Status,
              alignInColumn: "left",
              dataObject: "1"
            },
            {
              name: this.lang.table_header_Date,
              alignInColumn: "left",

            },
            {
              name: this.lang.table_header_User,
              alignInColumn: "left",

            },

          ]

          let cols =  [
            { "data": "id" },
            { "data": "revision" },
            { "data": "status" },
            { "data": "date" },
            { "data": "login" },


          ]
          let theHighestRev = {
            revisionId: 0,
            revision: 0,
            checked: false,
            login: ""
          };
          for (var j = 0, lej = this.dataTable.length; j < lej; j++){

            if (this.dataTable[j].revision > theHighestRev.revision){
              theHighestRev.revisionId = this.dataTable[j].id;
              theHighestRev.revision = this.dataTable[j].revision;
              theHighestRev.login = this.dataTable[j].login;

            }
          }
          this.$store.dispatch("setPartRevisionId", theHighestRev.revisionId);

          let columnDefs = [];
          var len = columns.length;
          for (var i = 0; i < len; i++){

            var el = {};

            var classname = '_dt-body-'+ columns[i].alignInColumn;

            el = {
              targets: i,
              className: classname,

              render: function ( data, type, row, meta ) {
                if (data == null) {
                  data = "";
                }

                data = $.fn.dataTable.render.text().display(data);
                if (data.display != undefined) {
                  data.display = $.fn.dataTable.render.text().display(data.display);
                }

                  if(meta.col == 0){


                  let  accepted = true;
                  let checked = "";
                  let disabled = "";

                  if (theHighestRev.revisionId == row.id){
                    theHighestRev.checked = true;
                    checked = "checked";
                    if (_vue.dataTable.length == 1){
                      disabled = "disabled";
                    }
                    

                  }

                  row.login = $.fn.dataTable.render.text().display(row.login);

                  let str = "<div class=\"custom-control custom-checkbox \"><input " + checked + " " + disabled + "  type=\"checkbox\" class=\"custom-control checkbox_type btn-primary\" id=\"selected_" + data + "_" + row.revision + "\" data-user=\""+row.login+"\" value=\""+ accepted +"\"></div>";

                    return str;
                  } else if (meta.col == 1) { 
                  
                    return data;
                }else if (meta.col == 2){

                  let variant = Tools.getStatusColor(data.display);

                  return "<b-badge class='badge badge-"+variant+" '>"+data.display+"</b-badge>"
                }else if (meta.col == 3) {
                  if (data == ""){
                    return data;
                  }
                  return Tools.longDateToShort(data);
                }else{
                  return data;
                }




              }





            }

            columnDefs.push(el);


            var th = document.createElement("th");
            tr.appendChild(th);
            

            var br = document.createElement("br");
            th.appendChild(br);
            var tx = document.createTextNode(columns[i].name);
            th.appendChild(tx);


          }


          var json = {};
          json.paging = false;
          json.info = false;
          json.dom = 'f<t>';
          json.data= this.dataTable;
          json.myColumnFormats = columns;
          json.select = false;
          json.order = [[1, "desc"]];

          json.columns = cols;

          json.columnDefs = columnDefs;
          json.initComplete = function () {


            

          }

          this.$store.dispatch("selectRevisionRow", theHighestRev);


          if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
              this.mainTable.destroy();
              
          }

          var _vue = this;

          this.mainTable = $('#t_'+this.id).DataTable(json);

          this.mainTable.columns.adjust().draw();

          //hide first column in table
          //this.mainTable.column( 0 ).visible( false );

          //search input change view
          var searchplace = document.getElementById("t_"+this.id + "_filter").firstChild

          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }
          searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm")




          $(".checkboxtable").on("click", noclick);


          function noclick(e){

              e.stopPropagation();

          }

          $('#t_revisionHistory input[type="checkbox"]').click(function(e) {

            var s = e.target.id.split("_");
           

            let obj = {
              revisionId: parseInt(s[1]),
              checked: e.target.checked,
              revision: parseInt(s[2]),
              login: this.dataset.user
            }
            
            if (e.target.checked == true){
              _vue.$store.dispatch("selectRevisionRow", obj)
            }else{
              _vue.$store.dispatch("deselectRevisionRow", obj)
            }
            var arr = [];
            for (var i = 0, le = _vue.$store.getters.selectedRevisionRow.length; i < le; i++){
              if (_vue.$store.getters.selectedRevisionRow[i].checked == true){
                arr.push(_vue.$store.getters.selectedRevisionRow[i].key);
              }
            }



            //var obj = {category: "", keys:arr};

            //_vue.$store.dispatch(_vue.$store.getters.sectionPrefix+"_getFormDetails",obj)

            //var objPinsTable = {key:arr[0], details: true}
            //_vue.$store.dispatch(_vue.$store.getters.sectionPrefix+"_getPinsTable", objPinsTable)

            //var objDetails = {key:arr[0], details: true}
            //      _vue.$store.dispatch(_vue.$store.getters.sectionPrefix+"_getPinsTable", objDetails)
            //      _vue.$store.dispatch(_vue.$store.getters.sectionPrefix+"_getDependOnTable", objDetails)
            //      _vue.$store.dispatch(_vue.$store.getters.sectionPrefix+"_getUseInTable", objDetails)
                  //_vue.$store.dispatch(_vue.$store.getters.sectionPrefix+"_getTasksTable", objDetails)

          })

          //_vue.selectRevisions();


        },
        selectRevisions(){
          
          for (var i = 0, le = this.dataTable.length; i < le; i++){
            
            if (this.dataTable[i][0].id == this.elementId){

              document.getElementById("n_"+ this.dataTable[i][0].id ).checked = true;
              this.$store.dispatch("selectRevisionRow", {revisionId: this.dataTable[i][0].id, checked: true})

            }
          }

          var arr = [];
          for (var i = 0, le = this.$store.getters.selectedRevisionRow.length; i < le; i++){
            if (this.$store.getters.selectedRevisionRow[i].checked == true){
              arr.push(this.$store.getters.selectedRevisionRow[i].id);
            }
          }

          //var obj = {category: "", keys:arr};

          //this.$store.dispatch(this.$store.getters.sectionPrefix+"_getFormDetails", obj)

          //var objDetails = {key:arr[0], details: true}

                  //this.$store.dispatch(this.$store.getters.sectionPrefix+"_getDependOnTable", objDetails)
                  //this.$store.dispatch(this.$store.getters.sectionPrefix+"_getUseInTable", objDetails)
                  //this.$store.dispatch(this.$store.getters.sectionPrefix+"_getTasksTable", objDetails)

                  //this.$store.dispatch(this.$store.getters.sectionPrefix+"_getPinsTable", objDetails)
        }

      },
      destroyed(){

        this.$store.dispatch("deselectAllRevisionRow")
      }


  }
</script>
<style lang="scss">
  .RevisionTableComponent{
    table{
      font-size: 0.75rem;
      padding: 0px !important;

    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .badge{
      margin-right: 1px;
      margin-top: 2px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/RevisionTableComponent.vue